<template>
  <div class="identification-stat">
    <a-row type="flex" :gutter="10" class="filters">
      <a-col flex="1">
        <tabs v-model="currentType" :tabs="typeTitles">
          <div :key="types.TYPE_DIAGRAM"></div>
        </tabs>
      </a-col>
      <a-col flex="1">
        <date-picker
          style="width: 100%; min-width: 200px; height: 40px;"
          label="Дата:"
          :value="date"
          :enabledDatesArray="dates"
          format="YYYY-MM-DD"
          class="white-date-picker"
          @input="date = $event"
        />
      </a-col>
    </a-row>

    <div class="block-wrapper">
      <h3>Всего обработано: 1100 чеков</h3>

      <a-row v-if="currentType === 'Диаграмма'" type="flex">
        <a-col flex="1">
          <v-chart class="chart" :option="identificationChartOptions" />
        </a-col>
        <a-col flex="1">
          <v-chart class="chart" :option="ipcChartOptions" />
        </a-col>
        <a-col flex="1">
          <v-chart class="chart" :option="okpd2ChartOptions" />
        </a-col>
        <a-col flex="1">
          <v-chart class="chart" :option="okatoChartOptions" />
        </a-col>
      </a-row>
      <div v-else>
        <the-table
          :headerHeight="0"
          :config="tableHeader"
          :defaultSort="[]"
          :data="tableData"
          :canHideColumns="false"
        />
      </div>
    </div>

<!--      <a-row type="flex" :gutter="10" class="filters">-->
<!--        <a-col flex="1">-->
<!--          <input-enum-->
<!--            v-model="category" :options="categories"-->
<!--            :allowClear="false"-->
<!--          />-->
<!--        </a-col>-->

<!--        <a-col flex="1">-->
<!--          <input-enum v-model="region" :options="regions" :allowClear="false"/>-->
<!--        </a-col>-->

<!--        <a-col flex="1">-->
<!--          <input-enum v-model="city" :options="cities" :allowClear="false"/>-->
<!--        </a-col>-->
<!--      </a-row>-->

<!--    <div class="block-wrapper">-->
<!--      <a-table-->
<!--        :class="['table']" :columns="columns" :data-source="rows"-->
<!--        :pagination="false"-->
<!--      />-->
<!--    </div>-->
  </div>
</template>

<script>
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import { TooltipComponent, LegendComponent } from 'echarts/components';
import VChart from 'vue-echarts';
import Tabs from '@/components/base/Tabs.vue';
import TheTable from '../../pages/table/table/TheTable';
import {apolloClient} from "@/apolloClient";
import TABLE_QUERY from "@/queries/table";
import {bus, storage} from "@/helpers";
import DatePicker from "@/components/base/DatePicker"

const apiUrl = process.env.VUE_APP_ROSSTAT_API_URL;

use([CanvasRenderer, PieChart, TooltipComponent, LegendComponent]);

const types = Object.freeze({
  TYPE_DIAGRAM: 'Диаграмма',
  TYPE_TABLE: 'Таблица',
});

export default {
  name: 'IdentificationStat',

  components: {
    TheTable,
    Tabs,
    VChart,
    DatePicker
  },

  data: () => ({
    types,
    currentType: types.TYPE_DIAGRAM,

    identificationChartOptions: {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'bottom',
        data: ['Товары, прошедшие идентификацию', 'Неидентифицированные товары'],
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['35%', '35%'],
          data: [
            { value: 1000, name: 'Товары, прошедшие идентификацию' },
            { value: 100, name: 'Неидентифицированные товары' },
          ],
          labelLine: {
            show: false,
          },
          label: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    },

    ipcChartOptions: {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'bottom',
        data: ['Привязанные к ИПЦ', 'Не привязанные'],
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['35%', '35%'],
          data: [
            { value: 550, name: 'Привязанные к ИПЦ' },
            { value: 198, name: 'Не привязанные' },
          ],
          labelLine: {
            show: false,
          },
          label: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    },

    okpd2ChartOptions: {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'bottom',
        data: ['Привязанные к ОКПД2', 'Не привязанные'],
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['35%', '35%'],
          data: [
            { value: 352, name: 'Привязанные к ОКПД2' },
            { value: 198, name: 'Не привязанные' },
          ],
          labelLine: {
            show: false,
          },
          label: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    },

    okatoChartOptions: {
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c} ({d}%)',
      },
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'bottom',
        data: ['Привязанные к ОКАТО', 'Не привязанные'],
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['35%', '35%'],
          data: [
            { value: 770, name: 'Привязанные к ОКАТО' },
            { value: 330, name: 'Не привязанные' },
          ],
          labelLine: {
            show: false,
          },
          label: {
            show: false,
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      ],
    },

    tableHeader: {
      displayFields: [
        {
          label: 'Название',
          field: 'Название',
          index: 'Название',
          name: 'Название',
          width: 500,
        },
        {
          label: 'Значение',
          field: 'Значение',
          index: 'Значение',
          name: 'Значение',
        },
      ],
    },
    tableData: {
      rows: [
        { Название: 'Количество товаров, прошедших идентификацию', Значение: '1000 (91%)' },
        {
          Название: 'Количество неидентифицированных товаров (нераспознанные чеки)',
          Значение: '100 (9%)',
        },
        {
          Название: 'Количество привязанных к справочникам товаров (ИПЦ, ОКПД2)',
          Значение: '900 (82%)',
        },
        {
          Название:
            'Количество непривязанных к справочникам товаров (неидентифицированные товарные позиции)',
          Значение: '200 (18%)',
        },
        { Название: 'Сколько было привязано к ОКАТО', Значение: '770 (70%)' },
        { Название: 'Количество созданных категорий', Значение: '5' },
      ],
    },
    columns: [
      {
        title: 'Название',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: 'Количество',
        dataIndex: 'amount',
        key: 'amount',
      },
    ],
    rows: [],
    // categories: [],
    // category: '',
    dates: [],
    date: '',
    // regions: [],
    // region: '',
    // region_code_arr: [],
    // cities: [],
    // city: '',
    // selected_okato: null,
    // city_code_arr: []
  }),

  computed: {
    typeTitles() {
      return [types.TYPE_DIAGRAM, types.TYPE_TABLE];
    }
  },
  watch: {
    // category() {
    //   this.refetch()
    // },
    date(){
      storage.set('dateFilter', this.date)
      this.refetch()
    },
    // region(){
    //   this.get_cities()
    // },
    // city(){
    //   this.refetch()
    // }
  },
  async mounted(){
    this.get_dates()
    // this.get_categories()
    // this.get_regions()
  },
  methods: {
    // async get_categories() {
    //   const prevCategory = this.category;
    //   const response = await this.axios.get(`${apiUrl}/report/get_categories`, {
    //         // headers: {
    //         //   'finch-auth': `Bearer ${storage.get('authToken')}`
    //         // }
    //       });
    //   const favorites = ['Картофель', "Морковь", 'Сметана', 'Соки фруктовые']
    //   this.categories = favorites.concat(Object.values(response.data).sort().filter(el => !(favorites.includes(el))));
    //   if (!this.categories.includes(prevCategory)) {
    //     this.category = this.categories[0];
    //   }
    // },
    // async get_regions() {
    //   const prevRegion = this.region;
    //   const client = apolloClient
    //     .query({
    //       ...TABLE_QUERY,
    //       variables: {
    //         type: 'Region',
    //         page: 0,
    //         pageSize: 10000,
    //       },
    //     })
    //     .catch((error) => {
    //       bus.$emit('error', {
    //         from: 'configFormLayout',
    //         description: `Ошибка получения конфига таблицы FNSClassesConfiguration`,
    //       });
    //       throw error;
    //     });
    //   client.then((res) => {
    //     const arr = [];
    //     res.data.table.documents.forEach(({ data }) => {
    //       arr[data.name_region] = data.okato;
    //     });
    //     this.regions = Object.keys(arr);
    //     if (!this.regions.includes(prevRegion)) {
    //       this.region = this.regions[0];
    //       this.region = 'Москва';
    //     }
    //     this.region_code_arr = arr;
    //     this.get_cities();
    //   });
    // },
    // async get_cities() {
    //   const prevCity = this.city;
    //   await this.axios
    //     .get(
    //       `${apiUrl}/report/get_okato_list_for_region?region=${this.region_code_arr[this.region]}`,
    //       // {
    //       //   headers: {
    //       //     'finch-auth': `Bearer ${storage.get('authToken')}`
    //       //   }
    //       // }
    //     )
    //     .then(({ data }) => {
    //       Object.keys(data).forEach((key) => {
    //         while (data[key].slice(-1) === '0') {
    //           data[key] = data[key].slice(0, -1);
    //         }
    //       });
    //       this.cities = Object.keys(data);
    //       if (!this.cities.includes(prevCity)) {
    //         this.city = this.cities[0];
    //       }
    //       this.selected_okato = data[this.city];
    //       this.city_code_arr = data;
    //     });
    // },
    async get_dates(){
      this.date = storage.get('dateFilter') || this.date
      const index = 'identified_statistic'
      await this.axios
        .get(`${apiUrl}/report/get_list_date_statistic?index=${index}`, {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          this.dates = data.sort()
          if (!this.date) {
            this.date = this.dates[0];
            storage.set('dateFilter', this.date)
          }
          // this.dates = ['2021-05-29']
          // this.date = '2021-05-29'
        })
        .catch((error) => {
          throw error;
        })
    },
    async refetch() {
      if (!this.date || !this.selected_okato || !this.category) return null
      await this.axios
        .get(`${apiUrl}/report/get_statistic_identified?date=${this.date}&region=${this.selected_okato}&category=${this.category}`,
          {
            // headers: {
            //   'finch-auth': `Bearer ${storage.get('authToken')}`
            // }
          })
        .then(({data}) => {
          this.rows=[]
          Object.keys(data).forEach((key)=>{
            const locale_arr = {'find':'Первично классифицированно', 'identified': 'Идентифицированно'}
            this.rows.push({'type': locale_arr[key] || key, 'amount': `${data[key].count} (${data[key].procent}%)`})
          })
        })
        .catch((error) => {
          throw error;
        })
    }
  }
};
</script>

<style lang="scss">
.identification-stat {
  .chart {
    height: 300px;
  }
  .ant-col>div {
    height: 40px;
    font-weight: 500;
  }
}
</style>
